
export const QUAM_COOKIE_KEY = 'quam-favorites'
export const QUAM_QUOTE_COOKIE_KEY = 'quam-quote'
